module.exports = __webpack_public_path__ + "static/indi-inns-footer-bg-7980218570427ab42f36efc46fa5a67a.png";